/**
 *
 *
 * @param {string} inputCountry
 * @return {*}  {boolean}
 */

import { useCurrentUser } from './useCurrentUser'
import { useUserSession } from './useUserSession'
import { getBrandIdentity } from '@utils/getBrandIdentity'

export const useCheckUserCountry = (inputCountry: string): boolean => {
  const { currentUser } = useCurrentUser()
  const { userSession } = useUserSession()

  if (currentUser?.__typename !== 'LoggedInUser' && !!userSession?.country) {
    return (
      userSession.country.toLocaleUpperCase() === inputCountry.toUpperCase()
    )
  }

  if (
    currentUser?.__typename === 'LoggedInUser' &&
    currentUser?.metadata?.country
  ) {
    return (
      currentUser.metadata.country.toLocaleUpperCase() ===
      inputCountry.toUpperCase()
    )
  }

  return false
}

export const useCheckMMUserCountry = (inputCountry: string): boolean => {
  const brandIdentity = getBrandIdentity()
  return brandIdentity === 'MerckMillipore' && useCheckUserCountry(inputCountry)
}
